import { render, staticRenderFns } from "./WheelOfFortuneContents.vue?vue&type=template&id=4af69df3&"
import script from "./WheelOfFortuneContents.vue?vue&type=script&lang=js&"
export * from "./WheelOfFortuneContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports